export function LintBubble({ children, className = "", dark = false, testId }) {
  return (
    <div
      data-testid={testId}
      className={`speech rounded-2xl border px-4 py-3 text-sm leading-snug shadow-[0_12px_30px_-18px_rgba(31,58,44,0.45)] ${
        dark
          ? "border-white/10 bg-brand text-cream"
          : "border-border bg-surface-elevated text-navy"
      } ${className}`}
    >
      {children}
    </div>
  );
}
